import { TypographyVariantsOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyVariantsOptions = {
    fontFamily: 'Montserrat400',
    htmlFontSize: 16,
    fontSize: 14,
    h1: {
        fontSize: '2.5rem',
        fontFamily: 'Montserrat600',
    },
    h2: {
        fontSize: '2rem',
        fontFamily: 'Montserrat600',
    },
    h3: {
        fontSize: '1.75rem',
        fontFamily: 'Montserrat600',
    },
    h4: {
        fontSize: '1.5rem',
        fontFamily: 'Montserrat600',
    },
    h5: {
        fontSize: '1.25rem',
        fontFamily: 'Montserrat600',
    },
    h6: {
        fontSize: '1rem',
        fontFamily: 'Montserrat600',
    },
};
